import React, {useMemo, useRef} from 'react';
import {Layout} from 'antd';
import HeaderContainer from './pages/HeaderContainer';
import {Routes, Route} from 'react-router-dom';
import FooterContainer from './pages/FooterContainer';
import useWindowSize from "@hook/useWindowSize";
import { routes } from '@common/routes.js';
import './index.css'

const {Header, Footer, Content} = Layout;

function App() {
    const headerRef = useRef(null);
    const footerRef = useRef(null);

    const windowSize = useWindowSize();

    /** 内容最小高度 */
    const contentMinHeight = useMemo(() => {
        const headerHeight = headerRef.current?.offsetHeight || 0;
        const footerHeight = footerRef.current?.offsetHeight || 0;
        return windowSize.height - headerHeight - footerHeight;
    }, [windowSize])

    return (
        <Layout className="app-layout-container">
            <Header className="App-header" ref={headerRef}>
                <HeaderContainer/>
            </Header>
            <Content style={{ minHeight: contentMinHeight }}>
                <Routes>
                    {
                        routes.map(route => {
                            const LazyComponent = route.component;
                            return (
                                <Route
                                    key={route.key}
                                    path={route.path}
                                    element={<LazyComponent contentHeight={contentMinHeight} />}
                                />
                            );
                        })
                    }
                </Routes>
            </Content>
            <Footer className="App-footer" ref={footerRef}>
                <FooterContainer/>
            </Footer>
        </Layout>
    );
}

export default App;
